import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_ENDPOINTS } from '../Utils/ApiConfig';

const ResetPassword = () => {
  // Form states
  const [email, setEmail] = useState('');
  
  // UI states
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'
  
  // Set document title
  useEffect(() => {
    document.title = "Reset Password";
  }, []);

  // Request password reset
  const handleRequestReset = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Please enter your email address');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      // Get the current origin (e.g., http://localhost:3000)
      const origin = window.location.origin;
      const redirectUrl = `${origin}/setnewpassword`;
      
      const response = await fetch(API_ENDPOINTS.REQUEST_PASSWORD_RESET, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email,
          redirectUrl
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setMessage('Check your inbox for a reset link. The link will redirect you to set a new password.');
        setMessageType('success');
        setEmail('');
      } else {
        setMessage(data.error || 'Failed to send reset instructions. Please try again.');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Password reset request error:', error);
      setMessage('An error occurred. Please try again later.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">Reset Password</h1>
        
        {message && (
          <div className={`p-3 ${messageType === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'} rounded text-sm text-center mb-4`}>
            {message}
          </div>
        )}
        
        <form onSubmit={handleRequestReset} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="font-semibold text-gray-600">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          
          <button 
            type="submit" 
            className="mt-2 p-3 bg-blue-500 text-white font-semibold rounded hover:bg-blue-600 transition-colors disabled:bg-blue-300"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          
          <div className="text-center mt-4">
            <Link 
              to="/login" 
              className="text-blue-500 hover:text-blue-700 transition-colors"
            >
              Back to Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
